import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
// import LandingPage from './components/LandingPage.vue'

Vue.use(Router)

function onlineGuard (to, from, next) {
  if (!navigator.onLine) {
    store.commit('hideLoading')
    store.commit('showDialogue', {
      title: 'No internet!',
      subtitle: 'Please check your connection and try again.'
    })
    next(false)
    return
  }
  next()
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/more/:id',
      name: 'more',
      component: () =>
        import(/* webpackChunkName: "news" */ './components/More.vue'),
      props: true
    },
    {
      path: '/imprint',
      name: 'imprint',
      component: () =>
        import(/* webpackChunkName: "imprint" */ './views/Imprint.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () =>
        import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
      beforeEnter: onlineGuard
    },
    {
      path: '/register',
      name: 'register',
      component: () =>
        import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
      props: { newRegistration: true },
      beforeEnter: onlineGuard
    },
    {
      path: '/appInfo',
      name: 'appInfo',
      component: () =>
        import(/* webpackChunkName: "appInfo" */ './views/AppInfo.vue'),
      props: true,
      beforeEnter: onlineGuard
    },
    {
      path: '/#signin',
      name: 'signin'
    },
    {
      path: '/signout',
      name: 'signout',
      component: () =>
        import(/* webpackChunkName: "signout" */ './views/SignOut.vue'),
      beforeEnter: onlineGuard
    },
    {
      path: '/delete-account',
      name: 'delete-account',
      component: () =>
        import('./views/DeleteAccount.vue'),
      beforeEnter: onlineGuard
    },
    {
      path: '*',
      name: 'home',
      component: () =>
        import(/* webpackChunkName: "news" */ './components/Tabs.vue'),
      props: (route) => ({ sharingToken: route.query.token })
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.fullPath.startsWith('/#')) {
    next(false)
    return
  }
  store.commit('showLoading')
  next()
})

router.afterEach((to, from, next) => {
  store.commit('hideLoading')
})

export default router
